import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import ArticleCategory from '../../../smoothr-web-app-core/models/ArticleCategory';
import { Router } from '@angular/router';
import { ToOrderButtonComponent } from '../../components/to-order-button/to-order-button.component';
import { IonSearchbar, ModalController, PopoverController } from '@ionic/angular';
import { ModalInfoComponent } from '../../components/modal-info/modal-info.component';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleGroup from '../../../smoothr-web-app-core/models/ArticleGroup';
import { AppComponent } from '../../app.component';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { OrderType } from '../../../smoothr-web-app-core/enums/OrderType';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { environment } from '../../../environments/environment';
import { axiosErrorToMessage, defaultsToArticleOption, getAvailability, sleep } from '../../../smoothr-web-app-core/utils/utils';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { NavigationService, NAVIGATIONURLS } from 'src/app/services/navigation.service';
import { SelectLanguagePopoverComponent } from 'src/app/components/select-language-popover/select-language-popover.component';
import { BehaviorSubject, timer, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { TOGGLE_TAG } from 'src/app/components/menu-filters/menu-filters.component';
import { ModalInfoHalfPizzaComponent } from 'src/app/components/modal-info-half-pizza/modal-info-half-pizza.component';
import { WorkingHoursModalComponent } from 'src/app/components/working-hours-modal/working-hours-modal.component';
import { BannerImgModalComponent } from 'src/app/components/banner-img-modal/banner-img-modal.component';
import { AuthStrategy } from 'src/smoothr-web-app-core/models/AuthStrategy';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { ProductInfoModalComponent } from '../../components/product-info-modal/product-info-modal.component';
import { ExtraOptionModalComponent } from 'src/app/components/extra-option-modal/extra-option-modal.component';
import { CompressedStorageService } from '../../../smoothr-web-app-core/services/compression';
import { TracifyService } from '../../services/tracify.service';

@Component({
	selector: 'app-menu',
	templateUrl: './menu.page.html',
	styleUrls: ['menu.page.scss'],
})
export class MenuPage extends RepositoryDirective implements OnInit {
	static url = 'menu';

	@ViewChild(ToOrderButtonComponent, { static: false }) toOrderButton;
	@ViewChild('articleContent', { static: false }) articleList: ElementRef;
	@ViewChild(IonSearchbar, { static: false }) searchBar;
	@ViewChild('categoryList', { static: false }) categoryList;
	@ViewChild('inputDataSlider', { static: false }) slider;

	environment = environment;
	scrollEvents = true;
	loading = false;
	searchTerm = '';
	categories: ArticleCategory[] = [];
	moment = moment;
	PreorderType = PreorderType;
	searchBarOpen = false;
	compoundFilers: string[] = [];
	selectedToggleTag = TOGGLE_TAG.All;
	public isOpenBasket$ = new BehaviorSubject<boolean>(false);
	public showFilters = false;

	// Skeleton loading state management
	private minDisplayTime = 100; // Prevent flash on fast loads
	private dataLoaded$ = new BehaviorSubject<boolean>(false);
	private minTimeElapsed$ = timer(this.minDisplayTime).pipe(
		map(() => true),
		startWith(false)
	);

	// Combine loading state with timing to prevent flash
	showSkeleton$ = combineLatest([this.dataLoaded$.pipe(map(loaded => !loaded)), this.minTimeElapsed$]).pipe(
		map(([isLoading, timeElapsed]) => isLoading || !timeElapsed)
	);
	public categoryItemOffset = '';
	public categoryItemOffsetLast = '';
	get preorderType(): PreorderType {
		return this.order?.preorder?.type;
	}

	private mockVenueReadableId = [
		'losteria_berlin_tacheles',
		'losteria_berlin_alt_mahlsdorf',
		'losteria_berlin_mildred_harnack',
		'losteria_berlin_memhardtstrasse',
		'losteria_berlin_savignyplatz',
		'losteria_berlin_budapester',
		'losteria_berlin_hilda-geiringer',
		'losteria_copy_from_prod_new',
	];
	private showDialog = false;
	private extraToppingsTag = 'popup_rucola';

	constructor(
		public translate: TranslateService,
		protected repository: RepositoryService,
		private modalCtrl: ModalController,
		private snackbarCtrl: MatSnackBar,
		private analytics: AnalyticsService,
		private popover: PopoverController,
		private router: Router,
		private zone: NgZone,
		private tracifyService: TracifyService
	) {
		super(repository);
	}
	public selectedCategoryIndex$ = new BehaviorSubject<number>(0);
	private _selectedCategoryIndex = 0;

	get selectedCategoryIndex(): number {
		return this._selectedCategoryIndex;
	}

	set selectedCategoryIndex(value) {
		if (this._selectedCategoryIndex === value) {
			return;
		}
		this._selectedCategoryIndex = value;
		this.selectedCategoryIndex$.next(value);
		this.scrollTo(value);
	}

	get selectedCategory(): ArticleCategory {
		return this.categories[this.selectedCategoryIndex];
	}

	get active(): boolean {
		return (
			this.order &&
			OrderUtils.articleGroupsTotalPrice(
				this.order.orderedArticles,
				this.order.type,
				this.order.preorder.type,
				this.order.terminalorder ? this.order.terminalorder.type : null
			) > 0
		);
	}

	get index(): number {
		return this.categories.findIndex(category => category._id === this.selectedCategory._id);
	}

	static async navigate(router: Router) {
		await router.navigateByUrl(MenuPage.url);
	}

	async ngOnInit() {
		await super.ngOnInit();
		switch (window.location.pathname) {
			case '/' + NAVIGATIONURLS.order():
				break;
			case '/' + NAVIGATIONURLS.paymentCancel():
				console.log(this.translate.instant('order.payment_cancel'));
				this.snackbarCtrl.open(this.translate.instant('order.payment_cancel'), null, {
					duration: 2000,
				});
				break;
			case '/' + NAVIGATIONURLS.paymentFail():
				console.log(this.translate.instant('order.payment_fail'));
				this.snackbarCtrl.open(this.translate.instant('order.payment_fail'), null, {
					duration: 5000,
				});
				break;
		}

		// Start skeleton loading
		this.loading = true;
		this.dataLoaded$.next(false);

		// Load venue data asynchronously - don't block component initialization
		this.loadVenueData();
	}

	private async loadVenueData() {
		try {
			this.repository.venue.emit(
				await this.repository.getVenue(this.order && this.order.venue ? this.order.venue : environment.customerGroup + '_master')
			);
			this.reloadCategories();

			// End skeleton loading (respects minimum display time)
			this.loading = false;
			this.dataLoaded$.next(true);
			setTimeout(() => {
				this.handleScrolling();
				this.addPaddingForTheLastArticleElement();
			});

			// Show banner dialog for German venues on pickup flow only
			await this.showBannerDialog();
		} catch (error) {
			console.error('Error loading venue data:', error);
			this.loading = false;
			this.dataLoaded$.next(true);
			// Handle error - could show error message or retry
		}
	}

	addPaddingForTheLastArticleElement() {
		if (!this.categories?.length) {
			console.log('No categories');
			return;
		}
		if (this.categories[this.categories?.length - 1].articles.length === 1) {
			const article = document.querySelector('.last') as HTMLElement;
			article.style.paddingBottom = this.articleList.nativeElement.offsetHeight - article.offsetHeight - 40 + 'px'; // element padding
		}
	}

	// async helloAgain() {
	// 	try {
	// 		const result = (await Api.loginHelloAgain(AuthStrategy.HELLOAGAIN)).data;
	// 		window.location.href = result.url;
	// 	} catch (e) {
	// 		console.error(e);
	// 	}
	// }
	async showBannerDialog() {
		if (!this.venue) {
			return;
		}
		if (this.showDialog) {
			return;
		}
		// Only show on pickup flow (TAKE_AWAY), not delivery
		if (this.order?.preorder?.type !== PreorderType.TAKE_AWAY) {
			return;
		}
		// Only show for German venues
		if (this.venue.country !== 'de') {
			return;
		}
		try {
			this.showDialog = true;
			await BannerImgModalComponent.show(this.modalCtrl);
		} catch (e) {}
	}
	// largeScreen(): boolean {
	// 	return AppComponent.largeScreen;
	// }

	async scrollTo(index: number) {
		if (this.categories.length - 1 < index || index < 0) {
			return;
		}
		if (this.searchTerm !== '') {
			await sleep(100);
			await this.scrollTo(index);
			return;
		}
		this.scrollEvents = false;
		if (this.selectedCategoryIndex !== index) {
			this.selectedCategoryIndex = index;

			await this.scrollCategoryListTo(index);
			await sleep(100);
			await this.scrollArticleListTo(index);
		}
		this.scrollEvents = true;
	}

	async handleScrolling() {
		this.zone.runOutsideAngular(() => {
			if (!this.articleList.nativeElement) return;
			this.articleList.nativeElement.addEventListener('scroll', async (event: Event) => {
				const target = event.target as HTMLElement;
				const currentY = target.scrollTop + 80; //category-header height todo: remove 60

				const categoryElements = Array.from(target.children) as HTMLElement[];

				let categoryIndex = categoryElements.findIndex((el, index, array) => {
					const nextTop = index < array.length - 1 ? array[index + 1].offsetTop : Infinity;
					return currentY >= el.offsetTop && currentY < nextTop;
				});

				let prevIndex = -1;
				if (this.selectedCategory) {
					prevIndex = this.categories.findIndex(category => category._id === this.selectedCategory._id);
				}

				if (prevIndex === categoryIndex) {
					return;
				}

				await this.zone.run(async () => {
					this.selectedCategoryIndex = categoryIndex;
					this.selectedCategoryIndex$.next(categoryIndex);
					await this.scrollCategoryListTo(categoryIndex);
				});
			});
		});
	}

	private async scrollCategoryListTo(index: number) {
		if (
			index < 0 ||
			!this.categoryList?.nativeElement?.children[index] ||
			(!this.categoryList?.nativeElement?.scrollTo && !this.categoryList?.nativeElement?.scrollLeft)
		) {
			return;
		}
		this.categoryList.nativeElement.scrollTo(this.categoryList.nativeElement.children[index].offsetLeft, 0);
		await sleep(100);
	}
	checkPageIfHaveGrid(articleGroup: ArticleGroup) {
		return (
			articleGroup.article.groups.length > 0 &&
			articleGroup.article.groups.filter(it => !!it.tags.find(tag => tag.identifier === 'half_pizza')).length > 0
		);
		// return articleGroup.article.tags.find(it => it.identifier == 'half_pizza');
	}
	async openModal(item: Article) {
		if (this.loading) {
			return;
		}

		const articleGroup = new ArticleGroup();
		articleGroup.article = item;
		articleGroup.groups.push(...defaultsToArticleOption(item, [], item.defaults, this.order?.type, this.order.preorder.type));
		articleGroup.quantity = 1;
		if (this.checkPageIfHaveGrid(articleGroup)) {
			const modal = await this.modalCtrl.create({
				cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
				component: ModalInfoHalfPizzaComponent,
				componentProps: {
					articleGroup,
				},
				mode: 'ios',
				backdropDismiss: true,
			});
			await modal.present();
			const response = await modal.onDidDismiss();
			if (response.data && response.data.articleGroup) {
				// console.log(response.data.articleGroup);
				console.log(response.data.articleGroup);
				const test = JSON.parse(JSON.stringify(response.data.articleGroup)) as ArticleGroup;
				// console.log("TEST", test)
				// const testGrousp = response.data.articleGroup.groups;

				let groupsWithout = test.groups.filter(it => !it.dependsOn);
				test.groups = [];
				const foundAllDefaultGroups = test.article.groups.filter(it => it.tags.find(g => g.identifier == 'whole_pizza'));

				const newMap = new Map(foundAllDefaultGroups.map(it => [it?._id, it]));
				if (foundAllDefaultGroups) {
					response.data.articleGroup.groups.forEach(it => {
						if (newMap.has(it.group)) {
							test.groups.push(it);
						}
					});
				}
				groupsWithout
					.filter(it => !newMap.has(it.group))
					.forEach(group => {
						test.groups.push(group);
						response.data.articleGroup.groups.forEach(it => {
							if (it.dependsOn === group.article._id) {
								test.groups.push(it);
							}
						});
					});
				test.article.groups = [];
				test.article.groupDependencies = [];
				test.isHalfPizza = true;
				OrderUtils.addToOrder(this.order, test, this.analytics);

				// Track add to cart event
				this.tracifyService.trackAddToCart();

				await sleep(300);
				this.repository.onOrderChange(this.order);
			}
			return;
		}
		const modal = await this.modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
			component: ModalInfoComponent,
			componentProps: {
				articleGroup,
			},
			mode: 'ios',
			backdropDismiss: true,
		});
		await modal.present();
		const response = (await modal.onDidDismiss()) as { data: { articleGroup: ArticleGroup } };
		if (response.data && response.data.articleGroup) {
			if (response.data.articleGroup.groups.length <= 0) {
				const extraToppingsGroup = item.groups.find(group => group.tags.some(tag => tag.identifier === this.extraToppingsTag));
				if (extraToppingsGroup) {
					await ExtraOptionModalComponent.show(this.modalCtrl, this.order, response.data.articleGroup, extraToppingsGroup);
				}
			}

			OrderUtils.addToOrder(this.order, response.data.articleGroup, this.analytics);

			// Track add to cart event
			this.tracifyService.trackAddToCart();

			this.repository.onOrderChange(this.order);
		}
	}

	onSearchTermChanged(event) {
		this.searchTerm = event.detail.value;
		this.reloadCategories();
	}

	reloadCategories() {
		if (!this.venue) {
			this.categories = [];
			return;
		}
		const lowerSearchTerm = this.searchTerm && this.searchTerm !== '' ? this.searchTerm.toLocaleLowerCase() : null;
		this.categories = this.venue.articleCategories
			.filter(category => !category.hidden)
			.map(category => {
				const cat: ArticleCategory = JSON.parse(JSON.stringify(category));
				cat.articles = cat.articles.filter(article => {
					const available = getAvailability(article, OrderType.PREORDER, this.preorderType);
					if (lowerSearchTerm) {
						const keys = [
							article.name.de.toLocaleLowerCase(),
							article.name.en.toLocaleLowerCase(),
							cat.name.de.toLocaleLowerCase(),
							cat.name.en.toLocaleLowerCase(),
						];
						return available && keys.map(key => key.indexOf(lowerSearchTerm)).find(result => result >= 0) !== undefined;
					}
					return available;
				});

				if (this.selectedToggleTag !== TOGGLE_TAG.All) {
					cat.articles = cat.articles.filter(article => {
						if (this.selectedToggleTag === TOGGLE_TAG.Vegeterian) {
							return article.compound?.features?.vegetarian;
						} else if (this.selectedToggleTag === TOGGLE_TAG.Vegan) {
							return article.compound?.features?.vegan;
						} else if (this.selectedToggleTag === TOGGLE_TAG.Meat) {
							return (
								article.compound?.features?.beef || article.compound?.features?.chicken || article.compound?.features?.pork
							);
						} else if (this.selectedToggleTag === TOGGLE_TAG.Fish) {
							return article.compound?.features?.fish;
						} else if (this.selectedToggleTag === TOGGLE_TAG.Alcohol) {
							return !article.compound?.additives?.containsAlcohol;
						} else if (this.selectedToggleTag === TOGGLE_TAG.Spicy) {
							return article.compound?.features?.spicyLevel;
						} else {
							return false;
						}
					});
				}

				if (this.compoundFilers.length > 0) {
					cat.articles = cat.articles.filter(article => {
						let articleFilter = false;
						this.compoundFilers.forEach(it => {
							if (article?.compound?.features && article.compound.features[it] && article.compound.features[it] == true) {
								articleFilter = true;
							}
						});
						return articleFilter;
					});
				}

				return cat;
			})
			.filter(category => category.articles.length > 0);
		if (this.categories.length == 0) {
			this.snackbarCtrl.open(this.translate.instant('not_found_articles'), null, {
				duration: 3000,
			});
		}

		// // Apply padding for mobile after categories are loaded
		// const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
		// if (isMobile && this.categories.length > 0) {
		// 	// Small delay to ensure DOM is updated
		// 	setTimeout(() => {
		// 		this.ensureLastCategoryScrollable();
		// 	}, 100);
		// }
	}

	onVenue() {
		super.onVenue();
		if (!this.venue) {
			this.repository
				.getVenue(this.order && this.order.venue)
				.then(venue => {
					this.repository.venue.emit(venue);
				})
				.catch(_ => {
					this.reloadCategories();
					this.selectedCategoryIndex = 0;
				});
			return;
		}
		this.reloadCategories();
		this.selectedCategoryIndex = 0;
	}

	onVenueError(error) {
		super.onVenueError(error);
		this.snackbarCtrl.open(axiosErrorToMessage(this.translate, error));
		this.loading = false;
		this.dataLoaded$.next(true); // Fix: Ensure skeleton loading is hidden even on error
		this.snackbarCtrl.open(
			this.translate.instant('menu_page.venue_timed_out'),
			this.translate.instant('menu_page.venue_timed_out_action')
		);
	}

	async scrollArticleListTo(index: number) {
		const element: HTMLElement = this.articleList?.nativeElement?.children[index];

		if (!element) {
			return;
		}

		// Compute the Y position relative to the scroll container
		const elRect = element.getBoundingClientRect();
		const scrollRect = this.articleList.nativeElement.getBoundingClientRect();

		const targetY = Math.max(this.articleList.nativeElement.scrollTop + (elRect.top - scrollRect.top) + 1, 0);

		await this.articleList.nativeElement.scrollTo(0, targetY);
	}

	async goHome() {
		await this.repository.cleanRepository();
		// await this.navigationService.map();
		this.router.navigateByUrl('/map', {
			replaceUrl: true,
		});
	}
	async goMap() {
		await this.repository.cleanRepository();
		// await this.navigationService.map();
		this.router.navigateByUrl('/map', {
			replaceUrl: true,
		});
	}
	changeSearchbar() {
		this.searchBarOpen = !this.searchBarOpen;
	}

	clearInput() {
		this.searchTerm = '';
		this.searchBarOpen = !this.searchBarOpen;
		this.reloadCategories();
	}
	findFlag() {
		return '/assets/' + this.translate.currentLang + '.svg';
	}
	async showPopover(ev: any) {
		const popover = await this.popover.create({
			component: SelectLanguagePopoverComponent,
			event: ev,
			animated: true,
			showBackdrop: true,
		});
		return await popover.present();
	}

	toggleBasket() {
		requestAnimationFrame(() => setTimeout(() => this.isOpenBasket$.next(!this.isOpenBasket$.value)));
	}
	toggleTagValue(value: TOGGLE_TAG) {
		this.selectedToggleTag = value;
		this.reloadCategories();
	}
	showFiltersFunc(value: boolean) {
		this.showFilters = value;
	}
	selectedFiltersCompound(value: string[]) {
		this.compoundFilers = value;
		this.reloadCategories();
	}
	nextSlide() {
		this.slider.nativeElement.swiper.slideNext();
	}
	findCategoryIndex(categories: ArticleCategory[]) {
		return categories.find(it => it?._id === this.selectedCategory?._id) ?? categories[0];
	}

	openVenueInfo() {
		WorkingHoursModalComponent.show(this.modalCtrl, this.venue, this.order.preorder.type);
	}

	// New methods for the redesigned item cards
	goToBasket(article: Article) {
		// Add article to order and navigate to basket
		this.addItemToOrder(article).then(() => {
			this.isOpenBasket$.next(true);
		});
	}

	onCustomizeItem(event: { article: Article; event: Event }) {
		// Open the existing modal for customization
		this.openModal(event.article);
	}

	onAddItem(event: { article: Article; event: Event }) {
		// Add item directly to basket
		this.addItemToOrder(event.article);
	}

	onInfoItem(event: { article: Article; event: Event }) {
		// Show item information using the dedicated info modal
		ProductInfoModalComponent.show(this.modalCtrl, event.article, this.venue, this.order);
	}

	private async addItemToOrder(article: Article) {
		if (this.loading) {
			return;
		}

		const articleGroup = new ArticleGroup();
		articleGroup.article = article;
		articleGroup.groups.push(...defaultsToArticleOption(article, [], article.defaults, this.order?.type, this.order.preorder.type));
		articleGroup.quantity = 1;

		// Check if the item needs customization
		if (this.checkPageIfHaveGrid(articleGroup)) {
			// If it needs customization, open the modal instead
			this.openModal(article);
			return;
		}

		if (articleGroup.groups.length <= 0) {
			const extraToppingsGroup = article.groups.find(group => group.tags.some(tag => tag.identifier === this.extraToppingsTag));
			if (extraToppingsGroup) {
				await ExtraOptionModalComponent.show(this.modalCtrl, this.order, articleGroup, extraToppingsGroup);
			}
		}

		// Add directly to order
		OrderUtils.addToOrder(this.order, articleGroup, this.analytics);

		// Track add to cart event
		this.tracifyService.trackAddToCart();

		this.repository.onOrderChange(this.order);

		// Show success message
		this.snackbarCtrl.open(
			this.translate.instant('item_added_to_basket', { name: article.name[this.translate.currentLang] || article.name.de }),
			null,
			{ duration: 2000, panelClass: 'success-snackbar' }
		);
	}
}
